export const EVENTS = {
  OTP: {
    SEND_OTP: 'user.send_otp',
    SHOW_OTP_INPUT: 'user.show_otp_input',
    SHOW_OTP_VERIFICATION: 'user.show_otp_verification',
    OTP_SUBMIT_CONTACT: 'user.otp_submit_contact',
    OTP_VERIFY: 'user.otp_verify',
    OTP_VALIDATED: 'user.otp_validated',
    OTP_ERROR: 'user.otp_error',
    OTP_SENT: 'user.otp_sent',
    OTP_RESEND: 'user.otp_resend',
    OTP_CANCEL: 'user.otp_cancel',
  }
};
export const ENDPOINTS = {
  OTP: {
    SEND: '/otp-generator/generate/otp?group=ecoxurf&numberOfDigits=5&requestId=',
  }
};
